import {InviteUserType, UpdateWorkspaceType} from "./workspace.type";
import axios from 'axios';

// Find all workspaces
function getAllWorkspacesApi() {
    return axios({
        method: 'GET',
        url: '/api/v1/workspaces'
    });
}

// Show all users in workspace
function getWorkspaceUsersApi (uuid: string) {
    return axios({
        method: 'GET',
        url: `/api/v1/workspaces/${uuid}/users`
    });
}

// Show workspace details
function getWorkspaceDetailsApi(workspaceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}`
    })
}

// Remove user from workspace
function remoweUserApi(uuid: string, userId: string) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/workspaces/${uuid}/users/${userId}`
    });
}

// Invite to workspace.
function inviteUserApi(uuid: string, data: InviteUserType) {
    return axios({
        method: 'POST',
        url: `/api/v1/workspaces/${uuid}/invites`,
        data: data
    });
}

// Get invited to workspace
function getInvitedWorkspace(workspaceUuid: string){
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/invites-pending`
    })
}

// Update Workspace
function updateWorkspaceApi(uuid: string, data: UpdateWorkspaceType) {
    return axios({
        method: 'PATCH',
        url: `/api/v1/workspaces/${uuid}`,
        data: data
    });
}

// Accept regulation
function acceptRegulationApi(uuid: string) {
    return axios({
        method: 'PATCH',
        url: `/api/v1/workspaces/${uuid}/workspace-regulations`,
    });
}

// Update Workspace
function updateWorkspaceTypeApi(uuid: string, type:string) {
    return axios({
        method: 'POST',
        url: `/api/v1/workspaces-types/${uuid}`,
        data: {
            type: type
        }
    });
}

//Create workspace
function postWorkspace(data: {name: string, description: string, owner: string}){
    return axios({
        method: "POST",
        url: `/api/v1/workspaces`,
        data
    })
}

// Active workspace
async function postActivateWorkspaceApi(uuid: string){
    return axios({
        method: "POST",
        url: `/api/v1/workspaces-activate-email/${uuid}`
    })
}

// Block workspace
async function postBlockWorkspaceApi(uuid: string){
    return axios({
        method: "POST",
        url: `/api/v1/workspaces-blocked/${uuid}`
    })
}

// Block workspace V2
async function postBlockWorkspaceTypeApi(uuid: string, type:string){
    return axios({
        method: "PATCH",
        url: `/api/v1/workspaces/${uuid}/blocked-type`,
        data: {
            is_blocked: type
        }
    })
}

// Unblock workspace
async function postUnblockWorkspaceApi(uuid: string){
    return axios({
        method: "POST",
        url: `/api/v1/workspaces-unlocked/${uuid}`
    })
}

// Get unallocated workspaces
async function getWorkspacesToAllocate(){
    return axios({
        method: "GET",
        url: `/api/v1/workspaces-unallocated`
    })
}


export {
    getWorkspaceDetailsApi,
    getAllWorkspacesApi,
    getWorkspaceUsersApi,
    remoweUserApi,
    inviteUserApi,
    updateWorkspaceApi,
    postWorkspace,
    postActivateWorkspaceApi,
    postBlockWorkspaceApi,
    postUnblockWorkspaceApi,
    getWorkspacesToAllocate,
    getInvitedWorkspace,
    updateWorkspaceTypeApi,
    acceptRegulationApi,
    postBlockWorkspaceTypeApi
}
